<template>
    <div class="c-menu__mega-menu">
        <y-row>
            <y-col
                size="4"
                class="c-menu__mega-menu__part-one"
            >
                <div class="head-title">
                    <router-link
                        :to="to(items[0])"
                        class="link"
                    >
                        {{ items[0].text }}
                    </router-link>
                </div>
                <component
                    :is="checkPageParams(item)"
                    v-for="item in items[0].children"
                    :key="`mega-${item.id}`"
                    class="c-menu__mega-menu__link"
                    :to="to(item)"
                    @click="scrollToId(findId(item))"
                >
                    <img
                        v-if="item.icon"
                        :src="item.icon.link"
                        :alt="item.text"
                    >
                    <span>{{ item.text }}</span>
                </component>
                <div class="head-title mt-4">
                    <router-link
                        :to="to(items[1])"
                        class="link"
                    >
                        {{ items[1].text }}
                    </router-link>
                </div>
                <router-link
                    v-for="item in items[1].children"
                    :key="`mega-${item.id}`"
                    class="c-menu__mega-menu__link"
                    :to="to(item)"
                >
                    <img
                        v-if="item.icon"
                        :src="item.icon.link"
                        :alt="item.text"
                    >
                    <span>{{ item.text }}</span>
                </router-link>
            </y-col>
            <y-col
                class="c-menu__mega-menu__part-two"
                size="8"
            >
                <y-row>
                    <y-col size="6">
                        <div class="head-title">
                            <router-link
                                :to="to(items[2])"
                                class="link"
                            >
                                {{ items[2].text }}
                            </router-link>
                        </div>

                        <router-link
                            v-for="item in items[2].children"
                            :key="`mega-${item.id}`"
                            class="c-menu__mega-menu__link"
                            :to="to(item)"
                        >
                            <img
                                v-if="item.icon"
                                :src="item.icon.link"
                                :alt="item.text"
                            >
                            <span>{{ item.text }}</span>
                        </router-link>
                    </y-col>
                    <y-col size="6">
                        <div class="head-title">
                            <router-link
                                :to="to(items[3])"
                                class="link"
                            >
                                {{ items[3].text }}
                            </router-link>
                        </div>
                        <y-row>
                            <y-col
                                v-for="item in items[3].children"
                                :key="`mega-${item.id}`"
                                size="6"
                            >
                                <router-link
                                    class="c-menu__mega-menu__link"
                                    :to="to(item)"
                                >
                                    <img
                                        v-if="item.icon"
                                        :src="item.icon.link"
                                        :alt="item.text"
                                    >
                                    <span>{{ item.text }}</span>
                                </router-link>
                            </y-col>
                        </y-row>
                    </y-col>
                </y-row>
            </y-col>
        </y-row>
    </div>
</template>

<script>
    export default {
        name : 'MegaMenuItem',
        props: {
            items: Array,
        },
        methods: {

            /**
             * Make router link
             *
             * @param {object} item
             * @returns {string}
             */
            to(item) {
                if (typeof item.link === 'string') {
                    return this.$route.params.locale
                        ? `/${this.$route.params.locale}/${item.link.replace(/^\/|\/$/g, '')}`
                        : item.link;
                }
                return item.link;
            },
            /**
             * Check page params
             *
             * @param {object} item
             * @returns {string}
             */
            checkPageParams(item) {
                const param = item.link.split('#');
                if (param.length) {
                    if (`/${this.$route.params.locale}${param[0]}` === this.$route.path) {
                        return 'div';
                    }
                }
                return 'router-link';
            },
            /**
             * Scroll to specific id
             *
             * @param {string} id
             */
            scrollToId(id) {
                document.getElementById(id).scrollIntoView();
            },
            /**
             * find id
             *
             * @param {object} item
             * @returns {string}
             */
            findId(item) {
                const param = item.link.split('#');
                if (param.length && param.length === 2) {
                    return `${param[1]}`;
                }
                return '';
            },
        },
    };
</script>
